import React from 'react'
import {Preloader} from './Libro/Index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export default class LawsReader extends React.Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            content: this.props.content,
            preload: true
        }
    }

    __update = () => {
        this.setState({content: this.props.content})
    }

    componentDidUpdate(prevProps) {
        if (prevProps.content !== this.props.content) {
            this.__update();
        }
    }

    render = () => {
        let doc
        if (this.state.content !== null) {
            doc = this.state.content;
            doc = doc.replace(/<script[^>]*>/gi, ' <!-- ');
            doc = doc.replace(/<\/script>/gi, ' --> ');
        }
        return (
            <div className={`menu menu--right ${this.props.className}`}>
                <div className="menu__close" onClick={this.props.display}><FontAwesomeIcon className="menu__icon" icon={faTimes} /></div>
                {this.state.content
                    ? <div className="menu__laws-reader"><div dangerouslySetInnerHTML={{__html: doc}} /></div>
                    : <Preloader show={this.state.preload} />
                }
            </div>
        )
    }
}
